(function() {
  var Service,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.ProfileService = (function(superClass) {
    extend(ProfileService, superClass);

    function ProfileService(http) {
      this.http = http;
      void 0;
    }

    ProfileService.prototype.getProfileData = function() {
      return this.http.post('backend/grower/profile/get');
    };

    return ProfileService;

  })(Service);

}).call(this);
